export enum LanguageEnum {
    English = 'en',
    'Spanish (Chile)' = 'es-CL',
    French = 'fr',
    German = 'de',
    Russian = 'ru'
}
